import { OutliersPnlStrategy } from 'widgets/outliers/data/pnlStrategies/index';
import { realisedPnlStrategy } from 'widgets/outliers/data/pnlStrategies/realised';
import { unrealisedPnlStrategy } from 'widgets/outliers/data/pnlStrategies/unrealised';

export const totalPnlStrategy: OutliersPnlStrategy = {
    mapOrder: (
        order,
        benchmarkPrice: number | undefined,
        exchangeRate: number
    ) => {
        const realised = realisedPnlStrategy.mapOrder(
            order,
            benchmarkPrice,
            exchangeRate
        );
        const unrealised = unrealisedPnlStrategy.mapOrder(
            order,
            benchmarkPrice,
            exchangeRate
        );
        if (!realised || !unrealised) {
            return undefined;
        }
        return {
            pnl: realised.pnl + unrealised.pnl,
            benchmarkPerformance:
                order.lpD === order.avgPxC
                    ? realised.benchmarkPerformance
                    : (realised.benchmarkPerformance * order.fillQty) /
                          order.qty +
                      (unrealised.benchmarkPerformance * (order.rem ?? 0)) /
                          order.qty,
        };
    },
    requiredColumns: [
        ...realisedPnlStrategy.requiredColumns,
        ...unrealisedPnlStrategy.requiredColumns,
    ],
};
